import UserEditFilters, {
} from "root/s360components/UserRename/UserEditFilters";
import {useState} from "react";
import UserEditManager from "root/s360components/UserRename/UserEditManager";

const UserEditContainer = ({}) =>
{

    const [encSchoolId, setEncSchoolId ] = useState ( null ) ;
    const [userType, setUserType ] = useState ( null ) ;

    const onSchoolChange = ( data ) =>
    {
        setEncSchoolId( data.enc_school_id ) ;
    }

    const onUserTypeChange = ( data ) =>
    {
        setUserType( data.value ) ;
    }

    return (
        <div>
            <h2>User Edit Tool</h2>
            <p key='this-screen'>This screen allows admins to safely edit details for users by school and role.</p>
            <p key='All-users' style={{color: '#b77171'}}>All users can be accessed here</p>
            <label>Please select a school and user role</label>
            <UserEditFilters onSchoolChange={onSchoolChange} onUserTypeChange={onUserTypeChange} key='UEF'/>
            <UserEditManager encSchoolId={encSchoolId} userType={userType} key='UEM'/>
        </div>
    )
}

export default UserEditContainer;